import Adicionar from './Adicionar';
import Editar from './Editar';
import Lista from './Lista';

export const MaterialAdicionar = Adicionar;
export const MaterialEditar = Editar;
export const MaterialLista = Lista;
